import React from 'react';
import { AppBar, Toolbar, Typography, Avatar, Button, Box } from '@mui/material';
import {
    Notifications, Logout, Home, PhotoLibrary,
    Campaign, BroadcastOnHome
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface AppBarProps {
    handleLogout: () => void;
}

export default function AdminAppBar({ handleLogout }: AppBarProps) {
    const navigate = useNavigate();
    const poppins = { fontFamily: "'Poppins', sans-serif" };

    // Corrected: Icons are imported from @mui/icons-material
    // Corrected: Paths point to the correct routes
    const menuItems = [
        { label: 'Dashboard', path: '/Home', icon: <Home /> },
        { label: 'Broadcast', path: '/broadcast', icon: <BroadcastOnHome /> },
        { label: 'Media', path: '/media', icon: <PhotoLibrary /> },
        { label: 'Ads', path: '/ads', icon: <Campaign /> },
    ];

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                top: 0, // Ensures it sticks to the top
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(12px)',
                borderBottom: '1px solid #E9EDF7',
                zIndex: 1100
            }}
        >
            <Toolbar sx={{ py: 1 }}>
                <Avatar sx={{ bgcolor: 'orange', mr: 2, boxShadow: '0 4px 12px rgba(255,165,0,0.4)' }}>
                    <Notifications />
                </Avatar>

                <Typography variant="h6" sx={{ color: '#1B2559', fontWeight: 700, mr: 4, ...poppins }}>
                    237Showbiz
                </Typography>

                <Box sx={{ flexGrow: 1, display: 'flex', gap: 1 }}>
                    {menuItems.map((item) => (
                        <Button
                            key={item.label}
                            onClick={() => navigate(item.path)}
                            startIcon={item.icon}
                            sx={{ color: '#1B2559', textTransform: 'none', fontWeight: 600, borderRadius: '10px' }}
                        >
                            {item.label}
                        </Button>
                    ))}
                </Box>

                <Button
                    onClick={handleLogout}
                    variant="contained"
                    disableElevation
                    color="error"
                    startIcon={<Logout />}
                    sx={{ borderRadius: '12px', textTransform: 'none', px: 3, fontWeight: 600, ...poppins }}
                >
                    Logout
                </Button>
            </Toolbar>
        </AppBar>
    );
}